/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_C2Inputs */

const en_guide_json_vs_yaml_xml_c2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What each format is actually good at`)
};

const ko_guide_json_vs_yaml_xml_c2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`각 형식이 실제로 잘하는 일`)
};

const ja_guide_json_vs_yaml_xml_c2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各形式が実際に得意なこと`)
};

/**
* | output |
* | --- |
* | "What each format is actually good at" |
*
* @param {Guide_Json_Vs_Yaml_Xml_C2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_c2 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_C2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_C2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_c2(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_c2(inputs)
	return ja_guide_json_vs_yaml_xml_c2(inputs)
});